<template></template>

<script>
export default {
  data() {
    return {
      websocket: null,
      subscription: null,
    };
  },
  created() {
    if (this.subscription) return;

    this.websocket = this.$cable.connectAnonymously();
    this.subscription = this.websocket.subscriptions.create(
      { channel: 'WarmupSessionChannel', steam_id: this.$route.params.steam_id },
    );
  },
  beforeUnmount() {
    if (this.websocket) {
      this.websocket.disconnect();
    }
  },
};
</script>
